import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import StsA360RegStep2UsernamePostModel from '../../../models/sts-a360-reg-step2-username-post.model';
import { StsNotificationType } from '../../../models/sts-notification-type';
import { StsNotification } from '../../../models/sts-notification.model';
import { StsPortalStatus } from '../../../models/sts-portal-status';
import { StsRegexBluePrintModel } from '../../../models/sts-regex-blue-print.model';
import { StsTenant } from '../../../models/sts-tenant.model';
import { StsA360RegServicesService } from '../../../services/sts-a360-reg-services.service';
import { StsPortalStatusService } from '../../../services/sts-portal-status.service';
import { StsTenantService } from '../../../services/sts-tenant.service';
import { StsTfaRegServiceService } from '../../../services/sts-tfa-reg-service.service';
import {StsUserService} from "../../../services/sts-user.service";
import {StsUser} from "../../../models/sts-user.model";
import StsA360NotificationTokenModel from 'app/models/sts-a360-notification-token.model';


@Component({
  selector: 'app-account-reg-collect-email',
  templateUrl: './account-reg-collect-email.component.html',
  styleUrls: ['./account-reg-collect-email.component.scss']
})
export class AccountRegCollectEmailComponent implements OnInit {

  public model: StsA360RegStep2UsernamePostModel = new StsA360RegStep2UsernamePostModel();
  public errors: StsNotification[] = [];
  public signUpForm: FormGroup;
  public tenantInfo: StsTenant = new StsTenant();
  public triggerValidateEmitter: EventEmitter<void> = new EventEmitter<void>();
  public emailIsValid = true;
  public submitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  public isLogIn: boolean = false;
  public isLogin2FA: boolean = false;

  message: StsA360NotificationTokenModel;

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  constructor(private tfa: StsTfaRegServiceService,
              private regService: StsA360RegServicesService,
              private userService: StsUserService,
              private portalStatusService: StsPortalStatusService,
              private route: ActivatedRoute,
              private tenantService: StsTenantService,
              public fb: FormBuilder,
              private tntInfo: StsTenantService,
              private router: Router) {

    this.route.params.subscribe(params => {
      this.isLogIn = params['isLogIn'] === 'true';
      this.isLogin2FA = params['isLogin2FA'] === 'true';
      this.tenantService.getTenantSource().subscribe(tenant => {
        this.tenantInfo = tenant;

        this.portalStatusService.getPortalStatus().subscribe(
          (portalStatus: StsPortalStatus) => {
            let isSelfRegFlow = portalStatus.isSelfRegFlow;

            if (!params['id']) {
              console.log('User attempting to execute \'set username\' without permission! Redirecting to login.');
              this.router.navigateByUrl('/account/signin');
              return;
            }
            this.model = new StsA360RegStep2UsernamePostModel();
            this.model.id = params['id'];           
            
            
          });
      });

      this.signUpForm = this.fb.group({

        emailInput: new FormControl('',
          {
            validators: [
              (c: FormControl) => {
                if (!c.value) {
                  return {
                    emailRequired: {
                      valid: false
                    }
                  };
                }
                let re = atob(this.tenantInfo.usefulPatterns['email'] + '');
                re = re.replace(/(^\\A)|(\\Z$)/g, '');
                this.emailIsValid = (new RegExp(re)).test(c.value);
                return (new RegExp(re)).test(c.value) ? null : {
                  validateEmail: {
                    valid: false
                  }
                };
              },
              ] ,

            updateOn: 'submit'
          })
      });     

    });

  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  public triggerValidation(v) {

    this.signUpForm.controls['emailInput'].updateValueAndValidity();
  }

  public resetFields() {

    this.signUpForm.controls['emailInput'].reset();
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  public gotoHome(): void {
    this.router.navigateByUrl('/');
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  getReType(re: string): StsRegexBluePrintModel {
    let tmp = new StsRegexBluePrintModel();
    re = re.replace(/(^\\A)|(\\Z$)/g, '');
    tmp.regexp = new RegExp(btoa(re));
    tmp.model = this.model;
    return tmp;
  }

  gotoNextStep() {
    
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  onSubmit(): void {
    this.submitter.emit(false);
    this.triggerValidation('');
    if (this.signUpForm.valid) {
      this.submitter.emit(true);
      this.errors = [];
      let n = new StsA360RegStep2UsernamePostModel();
      n.id = this.model.id;
      let user = new StsUser();
      user.id = n.id;
      n.email = this.signUpForm.controls['emailInput'].value;
      user.hasEmailChanged = true;        
      user.personalEmail = n.email;

      //If Login we update the EmailAAddress. If Registeration workflow, we register the user.
      //Registration needs to happen here as we do not have any other endpoint to update the email address in the CRM
      if(!this.isLogIn){
        //Registration Flow
        n.username = this.message.UserName;
        this.regService.postStep2Answers(n).subscribe(rs => {
          this.submitter.emit(false);
          if (rs.success) {        
            //tenant has 2fa
            if (this.tenantInfo.isTfaEnabled) {
              let channel = this.tenantInfo.tfaPreferredMode;
              //2 channels are defined for the tenant
              if (this.tenantInfo.tfaDeliveryChannels && this.tenantInfo.tfaDeliveryChannels.length > 1 && this.tenantInfo.tfaDeliveryChannels.includes('SMS')) {
                this.router.navigateByUrl('/account/reg/sel-comm/' + user.id);
                return;
              }
              else {
                if (this.tenantInfo.tfaDeliveryChannels) {
                  channel = this.tenantInfo.tfaDeliveryChannels.includes('SMS') ? 'phone' : channel;
                }
                this.message.PreferredChannel = channel;
                this.regService.changeMessage(this.message);
              }

              let address = channel === 'phone' ? this.message.Phone : (n.email ? n.email : this.message.PersonalEmail);
              
              //If we have changed the email address then we need to update the message service as well
              this.message.PersonalEmail = n.email;
              this.regService.changeMessage(this.message);

              this.tfa.sendValidationEmail(channel, address).subscribe(a => {
                  if (a.success) {
                    this.router.navigateByUrl('/account/validate/email/' + user.id);
                  } else {
                    if (this.message.PreferredChannel === 'email' || this.message.PreferredChannel === 'personalemail') {
                      let e = new StsNotification();
                      e.code =  a.stsCode ||'sts-failed-tfa-email';
                      e.level = StsNotificationType.Error;
                      e.description = 'An error occurred while validating your email';
                      this.errors = [e];
                    }
                    else {
                      if (this.message.PreferredChannel == "phone") {
                        let e = new StsNotification();
                        e.code =  a.stsCode || 'sts-failed-tfa-email-phone';
                        e.level = StsNotificationType.Error;
                        e.description = 'an error occured while validating your phone';
                        this.errors = [e];
                      }
                      else {
                        let e = new StsNotification();
                        e.code = rs['sts-code'] || a.stsCode;
                        e.level = StsNotificationType.Error;
                        e.description = 'Submitted data contains errors';
                        this.errors = [e];
                      }
                    }
                  }
                });
            } else {
              this.router.navigate(['/account/password/new', { id: user.id }]);
            }

          }else{
            let e = new StsNotification();
            e.code = rs['sts-code'] || rs.stsCode;
            e.level = StsNotificationType.Error;
            e.description = 'Submitted data contains errors';

            if (e.code === 'sts-invalid-email'
              && (this.message.PreferredChannel === 'email' || this.message.PreferredChannel === 'personalemail')
              && !this.message.Email
              && !this.message.PersonalEmail
              && this.message.Phone
            ) {
              e.code = "STS_LOGIN_FAILED";
            }

            this.errors = [e];
          }
          
        });

      }
      else{
        //Login Flow
        //This Email will not be updated in the CRM
        this.userService.updateEmailAddress(user).subscribe(rs => {
          if (rs.success) {
            if(this.isLogin2FA){
              this.redirectTo2FAVerification();
            }
            else {
              document.location.href = '/';
            }
          }
          else{
            let e = new StsNotification();
            e.code = rs['sts-code'] || rs.stsCode;
            e.level = StsNotificationType.Error;
            e.description = 'submitted data contains errors';
            this.errors = [e];
          }

        });
      }    
    } else {
      let e = new StsNotification();
      e.code = 'sts-correct-email-errors';
      e.level = StsNotificationType.Error;
      e.description = 'submitted data contains errors';
      this.errors = [e];
    }
  }

  private redirectTo2FAVerification(): void {
    this.userService.getCommunicationChannels().subscribe(result => {
      if (result) {
        let deliveryChannels = this.tenantInfo.tfaDeliveryChannels;
        let communicationChannels = result.communicationChannels.map(channel => channel.Type);
        // channels available to the user
        let availableChannels = communicationChannels.filter(channel => deliveryChannels.includes(channel));

        // many delivery channels available
        if (availableChannels.length > 1 && availableChannels.includes('SMS')) {
          this.router.navigateByUrl('/account/2fa/sel-comm');
        } else if (availableChannels.includes('SMS')) { // only sms delivery available
          this.router.navigateByUrl('/account/2fa/validate/phone');
        } else if (availableChannels.includes('EMAIL')) { // only email delivery available
          this.router.navigateByUrl('/account/2fa/validate/email');
        } else { // no channels available
          this.notify('sts-no-communication-channels', 'You have no communication channels on file', StsNotificationType.Error);
          //this.submitButton.onSubmitFinished();
        }
      }
    });
  }

  private notify(code: string, description: string, type: StsNotificationType): void {
    let notification = new StsNotification();
    notification.code = code;
    notification.description = description;
    notification.level = type;

    this.errors.push(notification);
  }


  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@

  ngOnInit() {
    this.regService.currentMessage.subscribe(message => this.message = message);
  }

  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
  // @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@





}

